import { useKitData } from "@/data/use-kits-data";
import { useGroupSlug } from "@/hooks/use-group-slug";
import { useGroupUuid } from "@/hooks/use-group-uuid";
import { useKitUuid } from "@/hooks/use-kit-uuid";
import { Navigate } from "@tanstack/react-router";
import { ProjectPage } from "./ProjectPage";

/**
 * Redirects to the correct page based on the kit type. Projects go to strategy
 * and conversations go to talk. Others are not defined and will leave the page
 * blank.
 */
export default function KitRedirectPage() {
  const kitUuid = useKitUuid();
  const groupSlug = useGroupSlug();
  const groupUuid = useGroupUuid();
  const { kit } = useKitData(groupUuid, kitUuid);

  if (!groupSlug || !kitUuid) {
    return null;
  }

  if (kit?.type === "conversation" || kit?.type === "interview") {
    return (
      <Navigate
        to="/w/$groupSlug/k/$kitUuid/chat"
        params={{ kitUuid, groupSlug }}
        replace
      />
    );
  } else if (kit?.type === "project") {
    return <ProjectPage />;
  } else if (kit?.type === "repository") {
    return (
      <Navigate
        to="/w/$groupSlug/k/$kitUuid/knowledge"
        params={{ kitUuid, groupSlug }}
        replace
      />
    );
  } else if (kit?.type === "expert") {
    return (
      <Navigate
        to="/w/$groupSlug/k/$kitUuid/expert"
        params={{ kitUuid, groupSlug }}
        replace
      />
    );
  } else if (kit?.type === "template") {
    return (
      <Navigate
        to="/w/$groupSlug/k/$kitUuid/template"
        params={{ kitUuid, groupSlug }}
        replace
      />
    );
  }

  return <></>;
}
